import { render } from "./IconBar.vue?vue&type=template&id=372adbeb&scoped=true"
import script from "./IconBar.vue?vue&type=script&lang=js"
export * from "./IconBar.vue?vue&type=script&lang=js"

import "./IconBar.vue?vue&type=style&index=0&id=372adbeb&scoped=true&lang=css"

import exportComponent from "/Users/user/Development/spin-demo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-372adbeb"]])

export default __exports__